import React from "react";
import { Form, Input, Popover, Upload } from "antd";
import UploadUtils from "../../utilities/uploadUtils";
import SortDraggableList from "../SortDraggableList";
import { QuestionCircleOutlined } from "@ant-design/icons";

const WholeSaleWhyYouChooseSort = ({ data, setData, form }) => {
  const items =
    data?.why_you_choose?.map((item, index) => ({
      id: index.toString(),
      ...item
    })) || [];

  const renderContent = (field) => (
    <div>
      <Form.Item
        label="Name"
        name={[field.name, "name"]}
        rules={[
          {
            required: true,
            message: "This field is required"
          }
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label={
          <span>
            Image{" "}
            <Popover placement="right" title="W * H" content="40 x 40">
              <QuestionCircleOutlined />
            </Popover>
          </span>
        }
        name={[field.name, "image"]}
        {...UploadUtils.formItemProps}
        wrapperCol={{ span: 24 }}
      >
        <Upload {...UploadUtils.buttonPreviewProps}>
          <UploadUtils.CardContent />
        </Upload>
      </Form.Item>
    </div>
  );

  return (
    <SortDraggableList
      items={items}
      renderContent={renderContent}
      setData={setData}
      form={form}
      formField="why_you_choose"
      addContent={false}
      showRemoveOption={false}
      cardTitle="Why You Choose"
    />
  );
};

export default WholeSaleWhyYouChooseSort;
